import { MapMarkerBase } from "../../../GeoLocation/MapMarkerBase";

interface FacilityMarkerProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export function FacilityMarker({ onClick }: FacilityMarkerProps) {
  return (
    <MapMarkerBase
      outerColor={(theme) => theme.palette.primary.main}
      innerColor={(theme) => theme.palette.common.white}
      onClick={onClick}
    />
  );
}
